import { buildMatchAnalysis } from '../../utils/matchAnalysis.js';
import { rateHaxballPlayer, ratingEventEvidence, RATING_VERSION } from '../../utils/haxballRating.js';

export const sanitizeAvatarText = value => {
  if (typeof value !== 'string' || !value.trim()) return null;
  return Array.from(value.trim()).slice(0, 2).join('');
};

export function computePlayerRatingsForMatch(match, existingAnalysis = null) {
  const result = { red: [], blue: [], mvpNick: null, ratingsByNick: Object.create(null), modelVersion: RATING_VERSION };
  if (!match) return result;
  const analysis = existingAnalysis || buildMatchAnalysis(match);
  if (!analysis?.playerSummaries) return result;
  const evidence = ratingEventEvidence(match, analysis);
  const minutes = typeof match.gameTicks === 'number' && Number.isFinite(match.gameTicks)
    ? Math.max(0, match.gameTicks / 3600)
    : analysis.minutes;
  analysis.playerSummaries.forEach(summary => {
    if (!summary || !['red', 'blue'].includes(summary.team)) return;
    const key = summary.nick.trim().toLowerCase();
    const detail = rateHaxballPlayer(summary, { minutes, evidence: evidence.get(key) });
    if (!detail.active) return;
    const entry = {
      nick: summary.nick, team: summary.team, role: detail.role, position: summary.position,
      rating: detail.rating, ratingRaw: detail.rating, baseline: detail.baseline,
      modelPrediction: null, modelVersion: RATING_VERSION,
      provisional: detail.provisional, breakdown: detail,
      nation: summary.player?.nation || summary.player?.country || null,
      avatar: sanitizeAvatarText(summary.player?.avatar ?? summary.player?.Xb ?? summary.avatar),
      avatarUrl: summary.player?.avatarUrl || null
    };
    result[summary.team].push(entry);
    result.ratingsByNick[key] = entry;
  });
  const sort = (a, b) => b.rating - a.rating || a.nick.localeCompare(b.nick);
  result.red.sort(sort);
  result.blue.sort(sort);
  const eligible = [...result.red, ...result.blue].filter(player => !player.provisional).sort(sort);
  // Equal displayed performances remain equal; no alphabetical rating offsets.
  if (eligible.length && (eligible.length === 1 || eligible[0].rating > eligible[1].rating)) result.mvpNick = eligible[0].nick;
  return result;
}

export default computePlayerRatingsForMatch;
